import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useLocalesMgr} from 'coreHooks';
import {ICountryPriceLocaleSettings} from 'coreStore/data/configurations/types';

import {formattedMoney} from './helpers';
import {EPriceType, IMoneyProps} from './IMoney';

const Money = ({
	value,
	currency,
	classNames = '',
	showLocalizedPrices = true,
	priceType = EPriceType.PRICE_SHORT,
	spaceBetweenCurrencyAndPrice = false,
	locale,
	...options
}: IMoneyProps) => {
	const intl = useIntl();
	const localesMgr = useLocalesMgr();
	const country = localesMgr.getCurrentCountry();
	const localeSettings = country.getLocaleSettings();
	const countryCurrencySymbol = country.getCurrencySymbol();

	if (priceType !== EPriceType.PRICE_LONG && priceType !== EPriceType.PRICE_SHORT) {
		priceType = EPriceType.PRICE_SHORT;
	}

	const countryPriceConfig = localeSettings[priceType] as ICountryPriceLocaleSettings;

	if (showLocalizedPrices) {
		return Intl.NumberFormat(intl.locale, {
			style: 'currency',
			currency: currency,
			currencyDisplay: 'symbol',
			...options,
		}).format(value);
	}

	const valueToRender = formattedMoney({
		countryPriceConfig,
		value,
		currency,
		options,
		spaceBetweenCurrencyAndPrice,
		countryCurrencySymbol,
		priceType,
		locale,
	});

	return <span className={cn('money', classNames)}>{value ? valueToRender : '-'}</span>;
};

export default Money;
